var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "arbitration" }, [
    _c("div", { staticClass: "arbitration-content" }, [
      _c("div", { staticClass: "arbitration-title" }, [
        _vm.status === 32
          ? _c("div", { staticClass: "medium" }, [
              _vm._v("Brand:" + _vm._s(_vm.message.brandName))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === 33
          ? _c("div", { staticClass: "medium" }, [
              _vm._v("Platform Arbitration")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status !== 32
          ? _c("div", { staticClass: "medium" }, [
              _vm._v(_vm._s(_vm.message.username))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.message.createAt))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "arbitration-text" }, [
        _vm.status === 3 || _vm.status === 30
          ? _c("div", [
              _vm._v(
                "The Retailer (" +
                  _vm._s(_vm.message.username) +
                  ")  Arbitration initiated"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === 33
          ? _c("div", [_vm._v("The platfrom (ShopVidi)  complete arbitration")])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === 33
          ? _c("div", [
              _vm._v("\n      Arbitration result:\n      "),
              _vm.serviceOrderMessage["refundUndertaker"] === 1
                ? _c("span", [_vm._v("Brand commitment")])
                : _vm.serviceOrderMessage["refundUndertaker"] === 2
                ? _c("span", [_vm._v("Platfrom commitment")])
                : _c("span", [_vm._v("Retailer commitment")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === 31 || _vm.status === 32
          ? _c("div", [_vm._v("Submit Arbitration Information")])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [_vm._v("Arbitration reason:" + _vm._s(_vm.message.reason))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          key: Math.random()
            .toString(16)
            .slice(2),
          staticClass: "arbitration-swiper"
        },
        [
          JSON.stringify(_vm.imgListMessage) !== {}
            ? _c("img-swiper", {
                attrs: { edit: false, imgListMessage: _vm.imgListMessage }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3fb2d5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3fb2d5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/history-list/arbitration.vue
// module id = mLzq
// module chunks = 2